import React from 'react';

import {OpenInterfacePage} from 'pages/external-loading';
import {IFormAwareTableProps} from 'pages/table-page/query-params-aware-table/query-params-aware-table';

import {EXTERNAL_LOADING_ROUTES} from './external-loading.constants';

type TExtarnalLoadingPageResolverProps = Pick<IFormAwareTableProps,
    'entityName'
    | 'entityType'
    | 'url'
    | 'hideTitle'
    | 'scroll'
    >;

export const ExternalLoadingPageResolver = ({
    entityName,
}: TExtarnalLoadingPageResolverProps) => {
    switch (entityName) {
    case EXTERNAL_LOADING_ROUTES.OPEN_INTERFACE:
        return <OpenInterfacePage />;
    default:
        return null;
    }
};

type TIsExternalLoadingPageArgs = Pick<IFormAwareTableProps, 'entityName'>;

export const isExternalLoadingPage = (
    {entityName}: TIsExternalLoadingPageArgs,
) => Object.values(EXTERNAL_LOADING_ROUTES).includes(entityName);
